export const OrgHealthcareServiceTestIds = {
  filterRow: 'filter_row',
  filterLabel: 'filter_label',
  filterControls: 'filter_controls',
  filterSelection: 'filter_selection',
  optionOwn: 'option_own',
  optionAll: 'option_all',
  formCreateEndpoint: 'form_create_endpoint',
  fieldHealthcareServiceId: 'field_healthcare_service_id',
  fieldHealthcareservicename: 'field_healthcareservicename',
  fieldHealthcareservicenameInput: 'field_healthcareservicename_input',
  fieldOrganizationid: 'field_organizationid',
  fieldOrganizationname: 'field_organizationname',
  removeEndpointIcon: 'remove_endpoint_icon',
  addEndpointButton: 'add_endpoint_button',
  addEndpointIcon: 'add_endpoint_icon',
  tableSettingsComponent: 'table_settings_component',
  orgHcsTable: 'org_hcs_table',
  inputHealthcareserviceSearch: 'input_healthcareservice_search',
  createHealthcareServiceButton: 'create_healthcareService_button',
  deleteHealthcareserviceButton: 'delete_healthcareservice_button',
  updateHealthcareserviceButton: 'update_healthcareservice_button',
  buttonCancelEdit: 'button_cancel_edit',
  buttonConfirmEdit: 'button_confirm_edit'
} as const;
